import React, { useState } from 'react';
import { Check, Lock, Star } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

// Static rewards definitions for V1
const availableTitles = [
    { id: 'challenger', title: 'Challenger', description: 'Unlocked by default.', unlocked: true },
    { id: 'rookie', title: 'Rookie', description: 'Win 1 Showdown match.', unlocked: true },
    { id: 'veteran', title: 'Showdown Veteran', description: 'Win 10 Showdown matches.', unlocked: false },
    { id: 'spectator', title: 'Avid Spectator', description: 'Cheer 50 times.', unlocked: true },
    { id: 'champion', title: 'Nexus Champion', description: 'Finish a season in the Top 10.', unlocked: false },
];

const RewardsPage = () => {
    const [equippedTitle, setEquippedTitle] = useState('challenger');

    const handleEquipTitle = (titleId) => {
        const title = availableTitles.find(t => t.id === titleId);
        if (title.unlocked) {
            setEquippedTitle(titleId);
        }
    };

    return (
        <div className="w-full h-full bg-gradient-to-b from-slate-900/90 to-black/95 backdrop-blur-xl text-white p-4 md:p-8 flex flex-col overflow-hidden">
            <div className="text-center mb-10 mt-4">
                <h1 className="text-3xl md:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-500 font-orbitron drop-shadow-sm">Player Titles</h1>
                <p className="text-gray-300 mt-2 font-light">Select a title to display in the Showdown.</p>
            </div>
            <div className="max-w-3xl mx-auto space-y-4 w-full overflow-y-auto custom-scrollbar pb-20">
                {availableTitles.map(title => {
                    const isEquipped = equippedTitle === title.id;
                    return (
                        <div 
                            key={title.id}
                            className={`bg-gray-800/40 backdrop-blur-md border rounded-xl p-5 flex items-center justify-between transition-all ${!title.unlocked ? 'opacity-60 grayscale border-white/5' : 'hover:bg-gray-800/60 border-white/10'} ${isEquipped ? 'border-cyan-500/50 shadow-[0_0_15px_rgba(6,182,212,0.15)] bg-cyan-900/10' : ''}`}
                        >
                            <div className="flex items-center">
                                <div className="mr-5">
                                    {title.unlocked ? <Star className={` ${isEquipped ? 'text-cyan-400 fill-cyan-400/20' : 'text-yellow-500 fill-yellow-500/20'}`} size={32} /> : <Lock className="text-gray-500" size={32} />}
                                </div>
                                <div>
                                    <h2 className={`text-lg font-bold font-orbitron ${isEquipped ? 'text-cyan-300' : 'text-white'}`}>{title.title}</h2>
                                    <p className="text-sm text-gray-400">{title.description}</p>
                                </div>
                            </div>
                            <button 
                                onClick={() => handleEquipTitle(title.id)}
                                disabled={!title.unlocked}
                                className={`px-4 py-2 w-28 rounded-lg font-bold text-sm transition-all flex items-center justify-center border ${isEquipped ? 'bg-cyan-500/20 text-cyan-300 border-cyan-500/50' : 'bg-indigo-600 hover:bg-indigo-500 text-white border-white/10'} disabled:bg-gray-700 disabled:border-transparent disabled:text-gray-500 disabled:cursor-not-allowed`}
                            >
                                <AnimatePresence mode="wait">
                                    {isEquipped ? (
                                        <motion.div
                                            key="equipped"
                                            initial={{ opacity: 0, scale: 0.5 }}
                                            animate={{ opacity: 1, scale: 1 }}
                                            exit={{ opacity: 0, scale: 0.5 }}
                                            className="flex items-center gap-2"
                                        >
                                            <Check size={16} /> Equipped
                                        </motion.div>
                                    ) : (
                                        <motion.span
                                            key="equip"
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                            exit={{ opacity: 0 }}
                                        >
                                            Equip
                                        </motion.span>
                                    )}
                                </AnimatePresence>
                            </button>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default RewardsPage;
